import { Component, Optional, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MmDialogRefService } from '@metromarkets/components';

import { APP_EMPLOYEE_CUSTOMERS_LIST } from '~shared/constants';
import { AuthorizationHttpService } from '~app/modules/authorization/services/authorization-http.service';
import { AuthService } from '~app/modules/authorization/services/authorization-idam.service';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { EmployeeService } from '~app/modules/authorization/services/employee.service';
import { EmployeeGaTrackingService } from '~app/modules/authorization/services/employee-ga-tracking.service';

@Component({
  selector: 'app-impersonation-active-alert-dialog',
  templateUrl: './impersonation-active-alert-dialog.component.html',
  styleUrls: ['./impersonation-active-alert-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ImpersonationActiveAlertDialog {
  accountType$ = this.accountInfoService.accountType$;
  public handleStartWithNewCustomer = (e) =>
    this.employeeService.handleStopImpersonatingCustomer(e, this.goToCustomersList);

  constructor(
    @Optional() public dialogRef: MmDialogRefService<any>,
    private router: Router,
    private accountInfoService: AccountInfoService,
    private employeeService: EmployeeService,
  ) {
  }

  public goToCustomersList = () => {
    this.router.navigate([APP_EMPLOYEE_CUSTOMERS_LIST]).then(() => this.dialogRef.close());
  };

  public onEmployeeLogout() {
    this.employeeService.handleEmployeeLogout().subscribe(() => {
      this.dialogRef.close();
    });
  }

  public onCancel() {
    this.dialogRef.close();
  }
}
